<template>
  <app-modal ref="modal" name="invoice-tag-modal" :submit-on-enter="false" :title="title"
    :is-submitting="isLoading" @before-open="beforeOpen" @before-close="beforeClose" width="30%" @on-ok="onOk">
    <div class="d-flex justify-content-between mb-3">
      <button class="btn btn-outline-secondary btn-sm" @click="manageTag()">
        <i class="fal fa-tag"></i>
        {{ $t('tag.manageTag') }}
      </button>
      <button class="btn btn-outline-secondary btn-sm" @click="addTag()">
        <i class="fal fa-plus"></i>
        {{ $t('tag.createTag') }}
      </button>
    </div>
    <app-search-box :placeholder="$t('directory.filter')" class="mb-3" v-model="searchText">
    </app-search-box>
    <div v-for="tag in tags.filter(tag => tag.name.toLowerCase().includes(searchText.toLowerCase()))" @click="e => onClickTag(e, tag)" style="cursor: pointer;" class="tag-item d-flex justify-content-between mb-3" :key="tag.id">
        <div><i class="far fa-tag" :style='{ color: tag.hex_color }'></i>
        {{
          tag.name
        }}
        </div>
        <div v-if="selectTags.has(tag.id)"><i class="far fa-check"></i></div>
    </div>
  </app-modal>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import AppModal from '@/components/app-modal/';
import AppForm from '@/components/app-form/';
import AppSearchBox from '@/components/app-search-box';

export default {
  name: 'InvoiceTagDropDown',
  components: {
    AppForm,
    AppModal,
    AppSearchBox
  },
  data() {
    return {
      title: this.$t('invoice.setTag'),
      isLoading: false,
      searchText: '',
      selectTags: new Set(),
      invoices: [],
    };
  },
  computed: {
    ...mapState(['tags']),
  },
  created() {
    this.$bus.on('close-tag-modal', this.onCloseTagModal);
  },
  beforeDestroy() {
    this.$bus.off('close-tag-modal', this.onCloseTagModal);
  },
  methods: {
    ...mapActions(['setTag']),
    onCloseTagModal() {
    },
    addTag() {
      this.$modal.show('tag-modal', { model: { name: this.searchText } });
    },
    manageTag() {
      this.$modal.show('manage-tag-modal', { model: {} });
    },
    onClickTag(e, tag) {
      if (!this.selectTags.has(tag.id)) {
        this.selectTags.add(tag.id)
      } else this.selectTags.delete(tag.id);
      // this.$set(this, 'selectTags', this.selectTags);
      this.selectTags = new Set(this.selectTags);
    },
    onOk() {
      this.setTag({
        tags: [...this.selectTags],
        invoices: this.invoices,
      }).then(() => {
        // this.$bus.emit('on-unselect-items');
        this.$refs.modal.close();
      }).finally(() => {
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
      })
    },
    beforeClose() {
      this.invoices = [];
      this.selectTags = new Set();
      this.searchText = '';
      this.isLoading = false;
    },
    beforeOpen(params) {
      this.invoices = params.model;
      this.selectTags = new Set(params.selectTags.map(tag => tag.id));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/invoice/invoice-tag-modal.vue